var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pd-select-history"},[_c('div',{staticClass:"wrapper-select-history"},[_c('div',{staticClass:"wrapper-select",class:_vm.$route.name === 'historyearnpoint'
                    ? 'select-collect-points'
                    : 'select-use-points',on:{"click":function($event){return _vm.gotoPath('historyearnpoint')}}},[_c('span',[_vm._v("คะแนนที่ได้รับ")])]),_c('div',{staticClass:"wrapper-select",class:_vm.$route.name === 'historyburnpoint'
                    ? 'select-collect-points'
                    : 'select-use-points',on:{"click":function($event){return _vm.gotoPath('historyburnpoint')}}},[_c('span',[_vm._v("คะแนนที่แลก")])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }